RivalIQ.apps.Admin.apps.Company.module('views', function (views, App, Backbone, Marionette, $, _) {

    'use strict';

    views.EditHistoryItem = Marionette.ItemView.extend({
        template: '#adminCompanyEditHistoryItemTemplate',
        tagName: 'tr',

        templateHelpers: function () {
            const me = this;
            const model = me.model.toJSON();

            return {
                flags_before: me.countSetBits(model.needs_review_flags_before),
                flags_after: me.flagsAfter()
            };
        },

        flagsAfter: function () {
            const me = this;
            const flags = me.model.get('needs_review_flags_after');
            if (!_.isUndefined(flags) && !_.isNull(flags)) {
                return me.countSetBits(flags);
            }
            return '';
        },

        // count the number of set bits in a number
        // NOTE adapted from http://blog.faultylabs.com/2011.php?p=jsbitfun
        countSetBits: function (n) {
            if (n === null) {
                return 0;
            }

            n >>>= 0; // NOTE force uint32
            let count;
            for (count = 0; n; n &= n - 1) {
                count++;
            }
            return count;
        }
    });
});
